import { render } from "./ApprocheValeurs.vue?vue&type=template&id=1dd50597&scoped=true"
import script from "./ApprocheValeurs.vue?vue&type=script&lang=js"
export * from "./ApprocheValeurs.vue?vue&type=script&lang=js"

import "./ApprocheValeurs.vue?vue&type=style&index=0&id=1dd50597&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd50597"]])

export default __exports__